import { ScrollCaptain } from 'scroll-captain';
import './promotion-teaser.scss';

class PromotionTeaser {
    constructor (element, options) {
        // Defaults & Settings
        const defaults = {
            initAttr: 'data-promotionteaser',
            itemValue: 'item',
            imageWrapperValue: 'image-wrapper',
            contentValue: 'content',
            breakpoint: 768
        };

        this.settings = Object.assign({}, defaults, options);

        // DOM Elements
        this.$root = element;

        // Properties
        this.animations = null;
        this.breakpoint = window.matchMedia(`(min-width: ${this.settings.breakpoint}px)`);
        this.breakpointActive = this.breakpoint.matches;
    }

    initialize () {
        this.loadAnimation();
        this.setEvents();
    }

    loadAnimation () {
        this.animation = new ScrollCaptain(this.$root, {
            initAttr: this.settings.initAttr,
            animateImage: {
                targetSuffix: this.settings.imageWrapperValue,
                onscroll: true,
                translateY: this.breakpoint.matches && !window.reducedMotionActive ? { 0: 200, 40: 50, 60: -50, 100: -200 } : null
            },
            animateContentBlock: {
                targetSuffix: this.settings.contentValue,
                onscroll: true,
                translateY: this.breakpoint.matches && !window.reducedMotionActive ? { 0: 100, 40: 50, 60: -50, 100: -100 } : null
            },
            updateOnResize: () => {
                if (this.breakpoint.matches !== this.breakpointActive) {
                    this.breakpointActive = this.breakpoint.matches;
                    this.updateAnimation(false);
                }
            }
        });

        this.animationInview = new ScrollCaptain(this.$root, {
            initAttr: this.settings.initAttr,
            bottom: '-50%',
            animateContent: {
                targetSuffix: this.settings.itemValue,
                class: 'promotion-teaser__inner--inview',
                resetOnScrollDown: false
            },
        });
    }

    updateAnimation (updateRequired) {
        this.animation.defaultOptions.animateImage.translateY = this.breakpoint.matches && !window.reducedMotionActive ? { 0: 200, 40: 50, 60: -50, 100: -200 } : null;
        this.animation.defaultOptions.animateContentBlock.translateY = this.breakpoint.matches && !window.reducedMotionActive ? { 0: 100, 40: 50, 60: -50, 100: -100 } : null;

        if (updateRequired) {
            this.animation.update();
        }
    }

    setEvents () {
        window.addEventListener('motionPreferenceChanged', () => {
            this.updateAnimation(true);
        });
    }
}

export { PromotionTeaser };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-promotionteaser="root"]');
        $$roots.forEach($root => {
            const $rootAPI = new PromotionTeaser($root);
            $rootAPI.initialize();
        });
    }
});
